import React from 'react';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import EditIcon from '@mui/icons-material/Edit';

import { useAppMonitor } from '../../../../monitor';
import { startInsertTrussEnvelope } from '../../../../store/actions/layout/trussEnvelopeActions';
import { handleStandardSceneItemEditPropertiesAction } from '../../../../store/actions/sceneInteractionActions';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { SceneMenuContent } from '../common/SceneMenuContent';
import { SceneMenuItem } from '../common/SceneMenuItem';

export function RoofContainerMenu(props: { guid: string }) {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();

  const roofContainers = useAppSelector((state) => state.layout.roofContainers);
  const roofContainer = roofContainers[props.guid];

  if (roofContainer == null) throw new Error('Unable to find roof container with active menu.');

  return (
    <SceneMenuContent>
      <SceneMenuItem
        text="Add Truss Envelope"
        icon={<AddCircleIcon />}
        onClick={() => void dispatch(startInsertTrussEnvelope({ roofContainerGuid: props.guid }))}
      />

      <SceneMenuItem
        text="Edit Properties"
        icon={<EditIcon />}
        onClick={async () => {
          await dispatch(handleStandardSceneItemEditPropertiesAction('roofContainer', roofContainer));
          monitor.recordInteraction('Roof Container => Edit Properties menu item clicked');
        }}
      />
    </SceneMenuContent>
  );
}
